module.exports = __webpack_public_path__ + "img/product_bg_kr.1744f41.png";